<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>

		<!-- Sign Up Image And Headings -->
		<div class="sign-up-header" style="background-image: url('images/bg-signup.jpg')">
			<div class="content">
				<h1 class="mb-5">Sign Up</h1>
				<p class="text-lg">Use these forms to create new account in your project for free.</p>
			</div>
		</div>
		<!-- / Sign Up Image And Headings -->

		<!-- Sign Up Form -->
		<a-card :bordered="false" class="card-signup header-solid h-full" :bodyStyle="{ paddingTop: 0 }">
			<template #title>
				<h5 class="font-semibold text-center">Register With</h5>
			</template>
			<!-- <div class="sign-up-gateways">
    			<a-button>
					<img src="images/logos/logos-facebook.svg" alt="">
				</a-button>
    			<a-button>
					<img src="images/logos/logo-apple.svg" alt="">
				</a-button>
    			<a-button>
					<img src="images/logos/Google__G__Logo.svg.png" alt="">
				</a-button>
			</div>
			<p class="text-center my-25 font-semibold text-muted">Or</p> -->
			<a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit">
				<a-form-item class="mb-10">
					<a-input v-decorator="[
						'name',
						{ rules: [{ required: true, message: 'Please input your name!' }] },
					]" placeholder="Name">
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-input v-decorator="[
						'email',
						{ rules: [{ required: true, message: 'Please input your email!' }] },
					]" placeholder="Email">
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input v-decorator="[
						'userPwd',
						{ rules: [{ required: true, message: 'Please input your Password!' }] },
					]" type="password" placeholder="Password">
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input v-decorator="[
						'confirmPwd',
						{
							rules: [
								{ required: true, message: 'Please confirm your password!' },
								{ validator: this.checkIfPasswordMatch },]
						},
					]" type="password" placeholder="Confirm Password">
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-checkbox v-decorator="[
						'remember',
						{
							valuePropName: 'checked',
							initialValue: true,
						},
					]">
						I agree the <a href="#" class="font-bold text-dark">Terms and Conditions</a>
					</a-checkbox>
				</a-form-item>
				<a-form-item>
					<a-button type="primary" block html-type="submit" class="login-form-button">
						SIGN UP
					</a-button>
				</a-form-item>
			</a-form>
			<p class="font-semibold text-muted text-center">Already have an account? <router-link to="/sign-in"
					class="font-bold text-dark">Sign In</router-link></p>
		</a-card>
		<!-- / Sign Up Form -->

	</div>
</template>

<script>
import { register } from '../utils/user';
import { successNotification, warnNotification } from '../utils/util';

export default ({
	data() {
		return {
		}
	},
	beforeCreate() {
		// Creates the form and adds to it component's "form" property.
		this.form = this.$form.createForm(this, { name: 'normal_login' });
	},
	methods: {
		checkIfPasswordMatch(rule, value, callback) {
			if (value && value !== this.form.getFieldValue('userPwd')) {
				callback('Two passwords that you enter is inconsistent!');
			} else {
				callback();
			}
		},
		// Handles input validation after submission.
		handleSubmit(e) {
			let _that = this;
			e.preventDefault();
			this.form.validateFields((err, values) => {
				if (!err) {
					console.log('Received values of form: ', values);
					values.userName = values.name;
					register(values).then(data => {
						if (data.code === 0) {
							sessionStorage.setItem("token", data.data.token);
							successNotification("成功", "注册成功");
							setTimeout(() => {
								this.$router.push('/');
							}, 1500);
						} else {
							console.info("注册失败")
							warnNotification("失败", data.msg);
						}
					})
						.catch(err => {
							console.info("err:", err)
						})
				}
			});
		},

	},

})

</script>

<style lang="scss">
// /* 覆盖默认的选中颜色 */
// .ant-checkbox-checked .ant-checkbox-inner {
// 	background-color: #ED1C24;
// 	border-color: #ED1C24;
// }

// .ant-checkbox-wrapper:hover .ant-checkbox-inner,
// .ant-checkbox:hover .ant-checkbox-inner,
// .ant-checkbox-input:focus+.ant-checkbox-inner {
// 	border-color: #ED1C24;
// }

// .ant-checkbox-checked::after {
// 	border: 1px solid #ED1C24;
// }</style>